<template>
  <div>
    <md-card class="h-full">
      <md-card-header class="md-card-header-text md-card-header-green">
        <div class="card-text">
          <h4 class="title text-lg">{{ $t("class.progress_report") }}</h4>
        </div>
      </md-card-header>
      <md-card-content style="overflow-x: auto">
        <div class="md-layout mt-4 mb-10">
          <div class="md-layout-item md-size-30 md-small-size-100">
            <IsisDropdownInfinity
              :options="programSelect.options"
              :selected-value-props="programSelect.value"
              :displayValue="programSelect.displayValue"
              label="progress_report.program"
              @updateValueSelected="programSelect.value = $event"
              class="w-full ml-auto pb-1"
            ></IsisDropdownInfinity>
          </div>
          <div class="md-layout-item md-size-70 md-small-size-100">
            <IsisDropdownInfinity
              :options="progressSelect.options"
              :selected-value-props="progressSelect.value"
              :displayValue="progressSelect.displayValue"
              label="progress_report.progress"
              @updateValueSelected="progressSelect.value = $event"
              class="w-full ml-auto pb-1"
            ></IsisDropdownInfinity>
          </div>
        </div>

        <!--        PREVIEW-->
        <div v-if="progressDetail" style="min-width: 1024px">
          <h2 class="text-lg my-3 text-center">
            {{ progressDetail.title }}
          </h2>

          <div class="md-layout items-center">
            <div class="md-layout-item md-size-100 mb-3">
              <span
                :class="getClassStatus(progressDetail.status)"
                class="bg-[#F6C3FF] p-2 rounded font-normal"
              >
                {{ generateStatusReport(progressDetail.status) }}
              </span>
            </div>

            <div class="md-layout-item md-size-33 md-small-size-100">
              <span class="font-normal">
                {{ $t("submitted_report.report_type") }}:
              </span>
              {{ $t(`submitted_report.${progressDetail.report_type}`) }}
            </div>

            <div class="md-layout-item md-size-33 md-small-size-100">
              <span class="font-normal">
                Report template:
              </span>
              {{ progressDetail.report_template }}
            </div>

            <div class="md-layout-item md-size-33 md-small-size-100">
              <span class="font-normal"> {{ $t("common.term") }}: </span>
              {{ progressDetail.term && progressDetail.term.name }}
            </div>

            <div class="md-layout-item md-size-33 md-small-size-100">
              <span class="font-normal">
                {{ $t("progress_report.the_last_inputter") }}:
              </span>
              {{ progressDetail.inputter && progressDetail.inputter.full_name }}
            </div>

            <div class="md-layout-item md-size-33 md-small-size-100">
              <span class="font-normal">
                {{ $t("progress_report.the_last_reviewer") }}:
              </span>
              {{ progressDetail.reviewer && progressDetail.reviewer.full_name }}
            </div>
          </div>

          <IgsusHighSchoolReport
            v-if="progressDetail.report_template === 'high_school'"
            :form-props="progressDetail"
            reportTemplate="high_school"
            :isViewOnly="true"
            :embedded="true"
          />
          <TemplateProgressReport
            v-else
            :form-props="progressDetail"
            :reportTemplate="progressDetail.report_template"
            :term-id="progressDetail.term_id"
            :isViewOnly="true"
            :generateVietnamese="generateVietnamese"
            ref="templateProgressReport"
          />
        </div>

        <NoDataFound v-else />
        <!--        PREVIEW-->
      </md-card-content>
    </md-card>
  </div>
</template>
<script>
import { service_names } from "@/constants/Services";
import { getId } from "@/helpers/utils";
import { getClassStatus } from "@/pages/ProgressReport/Components/utils";
import IsisDropdownInfinity from "@/components/Base/IsisDropdownInfinity";
import TemplateProgressReport from "../../../../ProgressReport/Components/Templates";
import IgsusHighSchoolReport from "../../../../ProgressReport/Components/TemplateReportForProgress/IgsusHighSchoolReport";
import { generateStatusReport } from "@/helpers/text-helper";
import { ReportTemplates } from "../../../../../constants/Report";

export default {
  props: ["isActiveTab"],
  components: {
    TemplateProgressReport,
    IgsusHighSchoolReport,
    IsisDropdownInfinity
  },
  data() {
    return {
      getClassStatus,
      generateStatusReport,
      progressDetail: null,
      programSelect: {
        label: "common.grade",
        name: "program",
        value: "",
        displayValue: "",
        type: "select",
        options: []
      },
      progressSelect: {
        name: "progress",
        value: "",
        displayValue: "",
        type: "select",
        options: []
      }
    };
  },
  computed: {
    generateVietnamese() {
      const isDisplay =
        this.progressDetail.report_template === ReportTemplates.Standard
          ? "block"
          : "hidden";
      return "italic font-mono " + isDisplay;
    },
    studentId() {
      return this.$route.params.id;
    },
    pathGetProgress() {
      return `${service_names.user}/progress/student`;
    }
  },
  watch: {
    isActiveTab: function(newVal) {
      if (this.isActive) return;
      if (newVal) {
        this.getProgramList();
        this.isActive = true;
      }
    },
    "progressSelect.value"(progressId) {
      if (!progressId) {
        this.progressDetail = null;
        this.progressSelect.displayValue = "";
      }
      this.progressDetail = this.progressSelect.options.find(
        item => item.id === progressId
      );
      this.progressSelect.displayValue = this.progressDetail?.name;
    },
    "programSelect.value"(programId) {
      if (!programId) {
        this.programSelect.displayValue = "";
        return;
      }
      this.programSelect.displayValue = this.programSelect.options.find(
        item => item.id === programId
      )?.name;
      this.getProgressList(programId);
    }
  },
  methods: {
    async getProgramList() {
      const path = `${service_names.user}/students/${this.studentId}/programs`;
      const { data } = await this.$axios.get(path);
      this.refreshOptionsSelected();
      this.programSelect.options = data.map(item => {
        return {
          name: item.name,
          id: getId(item)
        };
      });
      if (!data.length) return;
      this.programSelect.value = getId(data[0]);
      this.programSelect.displayValue = this.programSelect.options[0]?.name;
    },
    refreshOptionsSelected() {
      this.progressSelect.options = [];
      this.progressSelect.value = "";
    },
    async getProgressList(programId) {
      const params = {
        student_id: this.studentId,
        program_id: programId,
        limit: 200
      };
      this.refreshOptionsSelected();
      const { data } = await this.$axios.get(this.pathGetProgress, params);
      this.progressSelect.options = data?.data?.reduce((acc, item) => {
        if (item.status === "Official") {
          acc.push({ ...item, name: item.title, id: getId(item) });
        }
        return acc;
      }, []);
      if (!this.progressSelect.options.length) return;
      this.progressSelect.value = getId(this.progressSelect.options[0]);
      this.progressSelect.displayValue = this.progressSelect.options[0]?.name;
    }
  }
};
</script>
